import { defaultCard } from 'types/deck'

import { DeckLeglaity, LegalityChecker } from '../deckLegality'
import { ERRORS } from '../legality.const'

const CheckLegality: LegalityChecker = (deck: DeckLeglaity) => {
  const commander = deck.commanders[0] || defaultCard
  const canBeCommander = commander.types.includes('Creature') || commander.types.includes('Planeswalker')

  if (!canBeCommander) deck.addCardError(ERRORS.REQUIRE_BRAWL_COMMANDER, commander)

  // Cannot use the prebuilt functions here since we have specific brawl outputs
  if (!deck.commanders.length) deck.addError(ERRORS.REQUIRE_BRAWL_COMMANDER)
  if (deck.commanders.length > 1) deck.addError(ERRORS.SINGLE_BRAWL_COMMANDER)

  deck.checkLegendaryCommander()

  const fullDeck = [...deck.mainboard, ...deck.commanders]

  for (const card of fullDeck) {
    deck.checkCardLegality(card)
    deck.checkCardQuantity(card, 1)

    if (deck.commanders.length) deck.checkCardColorIdentAgainstCommanders(card)
  }

  if (deck.deckSize !== 60) deck.addError(ERRORS.BRAWL_SIZE)
}

export default CheckLegality
